import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { USER_TYPE_ADMIN, USER_TYPE_WAREHOUSE } from '../types/auth/types';

interface AuthRouteProps {
  requireSuperuser?: boolean;
  allowWarehouseUser?: boolean;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ requireSuperuser = false, allowWarehouseUser = false }) => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireSuperuser) {
    const isAdmin = user.user_type === USER_TYPE_ADMIN;
    const isWarehouseAndAllowed = allowWarehouseUser && user.user_type === USER_TYPE_WAREHOUSE;

    if (!isAdmin && !isWarehouseAndAllowed) {
      return <Navigate to="/home" />;
    }
  }

  return <Outlet />;
};

export default AuthRoute;
